<template>
  <QToolbar class="row q-pa-md sai-application-header bg-white bdr-b-grey-4">
    <div class="full-height">
      <router-link :to="logoRoute" v-if="logoRoute">
        <img
          class="brand-logo full-height"
          :src="logo"
          :alt="`${theme} logo`"
        />
      </router-link>
      <img
        :class="[
          'brand-logo full-height',
          { 'cursor-pointer': $listeners['logo:click'] }
        ]"
        v-else
        :src="logo"
        :alt="logoAlt"
        @click="$emit('logo:click')"
      />
    </div>
    <slot name="header-left" />
    <QSpace />
    <slot name="header" />
    <QSpace />
    <slot name="header-right" />
    <SAIContactUsMenu
      v-if="displayMenu"
      :org-contact-email="orgContactEmail"
      :org-contact-phone="orgContactPhone"
    />
    <SAIProfileMenu
      :name="profileName"
      :email="profileEmail"
      :hide-logout="hideLogout"
      :alert="alert"
      :icon="profileIcon"
      @logout="$emit('logout')"
    >
      <slot />
    </SAIProfileMenu>
  </QToolbar>
</template>

<script>
import { QSpace, QToolbar } from 'quasar';
import getAsset from '../../../utils/get-asset';
import getTheme, { themes } from '../../../utils/themes';

export default {
  name: 'SAIApplicationHeader',
  data() {
    return {
      desktopSrc: undefined,
      mobileSrc: undefined
    };
  },
  props: {
    theme: {
      type: String,
      default: themes.novated.value
    },
    mobileLogo: Boolean,
    assetBase: String,
    logoRoute: String,
    alert: Number,
    profileName: String,
    profileEmail: String,
    logoAlt: {
      type: String,
      default: 'Home'
    },
    hideLogout: Boolean,
    displayMenu: Boolean,
    orgContactEmail: String,
    orgContactPhone: String,
    profileIcon: String
  },
  computed: {
    logo() {
      return this.mobileLogo ? this.mobileSrc : this.desktopSrc;
    }
  },
  watch: {
    theme: {
      async handler() {
        this.desktopSrc = await getAsset(
          getTheme(this.theme).logo.colour,
          this.assetBase
        );
        this.mobileSrc = await getAsset(
          getTheme(this.theme).logo.mobile,
          this.assetBase
        );
      },
      immediate: true
    }
  },
  components: {
    QToolbar,
    QSpace,
    SAIContactUsMenu: () => import('../../molecule/sai-contact-us-menu'),
    SAIProfileMenu: () => import('../../molecule/sai-profile-menu')
  }
};
</script>

<style lang="sass" scoped>
.sai-application-header
  height: 62px

@media (max-width: $breakpoint-xs-max)
  .sai-application-header
    height: 58px
</style>
